import { Components, Theme } from '@mui/material/styles';

export const flowDialogActions: Components<Theme>['MuiDialogActions'] = {
  defaultProps: {
    // disable space between buttons, we are using flex gap instead
    disableSpacing: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '32px 40px',
      // button next to each other
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '12px',
      // responsive
      [theme.breakpoints.down('md')]: {
        gap: '16px',
        padding: '24px',
        // switch to full width buttons bellow each other
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    }),
  },
};
